export enum DashboardType {
    Single = 'single',
    Column = 'column',
    Copy = 'copy'
}